import React, { PropTypes } from 'react'
import InputField from 'components/InputField/InputField';
import PasswordField from 'components/InputField/PasswordField';

const labels = {
  password: 'New password',
  password_confirmation: 'Repeat new password'
}

const NewPasswordForm = ({
  user,
  onSubmit,
  onFieldChange,
  errors,
  onPasswordTypeChange,
  passwordType
}) => (
  <div className="container_global_password">
    <h2 className="password_title">PASSWORD RESET</h2>
    <div className="container_password row">
      <form className="col s12" onSubmit={onSubmit}>
        <div className="row">
          <InputField
            className='col s12'
            label={labels['password']}
            onChange={onFieldChange}
            errors={errors['password']}
            autoComplete='new-password'
            field_name={'password'}
            value={user.password}
            type='password'
          />
          <PasswordField
            className='col s12'
            label={labels['password_confirmation']}
            onChange={onFieldChange}
            errors={errors['password_confirmation']}
            autoComplete='new-password'
            field_name={'password_confirmation'}
            value={user.password_confirmation}
            showPassword={passwordType == 'text'}
            onPasswordChangeVisibility={onPasswordTypeChange}
            autoComplete='current-password'
           />
          <div className="submit_center col s12">
            <input className="container_password_button" type="submit" name="" value="SIGN UP" />
          </div>
        </div>
      </form>
    </div>
  </div>
)

NewPasswordForm.propTypes = {
  user: PropTypes.object,
  onSubmit: PropTypes.func,
  onFieldChange: PropTypes.func,
  errors: PropTypes.object,
  onPasswordTypeChange: PropTypes.func,
  passwordType: PropTypes.string
}

export default NewPasswordForm



/** WEBPACK FOOTER **
 ** ./src/components/Authorization/NewPassword/NewPasswordForm.js
 **/